import { iconButtonAnimation } from "@domains/common/utils/animationHelper";
import { Share2Icon } from "@enkor/design/icons";
import { grayScale } from "@enkor/design/colors";
import useModalState from "@logics/hooks/useModalState";
import { ProjectInfoTrackingDataType } from "@domains/project/types/project";
import { getUrlWithUTMParams } from "@logics/utils/makeUTMparameter";
import { removeAmplitudeParams } from "@logics/utils/urlHandler";
import WebViewBridge from "@logics/utils/webViewBridge";
import { DEFAULT_TITLE } from "@logics/tags/GeneralHead";

import CancelReasonBottomSheet from "../../CancelReasonBottomSheet/CancelReasonBottomSheet";

import * as S from "./CancelButtonGroup.style";

interface CancelButtonGroupProps {
  projectId: string;
  projectInfo: ProjectInfoTrackingDataType;
  isProjectClosed?: boolean;
}

const CancelButtonGroup = ({
  projectId,
  projectInfo,
  isProjectClosed,
}: CancelButtonGroupProps) => {
  const { openModal } = useModalState();

  const handleClickShare = () => {
    const url = getUrlWithUTMParams(window.location.toString(), {
      utm_source: "letsfip",
      utm_medium: "share_button",
      utm_campaign: String(projectInfo.projectId),
    });

    const updatedUrl = removeAmplitudeParams(url);

    if (WebViewBridge.isInAppWebView()) {
      WebViewBridge.getInstance().triggerShareEvent({
        text: DEFAULT_TITLE,
        subject: projectInfo.projectTitle,
        uri: updatedUrl,
        fileName: DEFAULT_TITLE,
        imageNames: projectInfo.ProjectImageUrlList,
        imagePaths: projectInfo.ProjectImageUrlList,
      });
    }
  };

  const handleClickCancelation = () => {
    openModal({
      CustomComponent: (
        <CancelReasonBottomSheet
          projectId={projectId}
          projectInfo={projectInfo}
        />
      ),
    });
  };

  return (
    <S.SpacedBetweenWrapper>
      <S.ShareButtonBox
        type="button"
        {...iconButtonAnimation}
        onClick={handleClickShare}
      >
        <Share2Icon strokeColor={grayScale.white} />
      </S.ShareButtonBox>
      <S.UnderlineButton
        type="button"
        disabled={isProjectClosed}
        onClick={handleClickCancelation}
      >
        Leave edition
      </S.UnderlineButton>
    </S.SpacedBetweenWrapper>
  );
};

export default CancelButtonGroup;
